import React, { useEffect } from 'react';
import { Col, Grid, Title } from '@common/components';

import { useAppDispatch, useAppSelector } from '@app/hooks';
import { LayoutFilters } from '@dashboard/components';
import ResumeCards from '@dashboard/components/ResumeCards/ResumeCards';

import { selectFilter } from '@dashboard/slices/filters';
import { useCentersMutation } from '@dashboard/api/centers';
import { selectCenters, setCenters } from '@dashboard/slices/centers';
import { useTranslation } from 'react-i18next';
import NotResults from '@dashboard/components/NotResults/NotResults';
import CenterCard from '@dashboard/components/CenterCard/CenterCard';
import viewClasess from './CentersView.module.scss';

let isFetching = false;

export default function CentersView() {
  const dispatch = useAppDispatch();
  const currentCenters = useAppSelector(selectCenters);
  const currentFilters = useAppSelector(selectFilter);
  const { t } = useTranslation('dashboard\\CentersView');
  const filters = useTranslation('dashboard\\MainFilters');

  const [centers, { isLoading }] = useCentersMutation();

  const filterCenters = async () => {
    isFetching = true;
    const q = {
      ...currentFilters,
      publication: currentCenters.selectedPublication,
    };

    try {
      const analysis = await centers(q).unwrap();
      dispatch(setCenters(analysis.data));
    } catch (ex) {
      isFetching = false;
    } finally {
      isFetching = false;
    }
  };

  useEffect(() => {
    if (
      currentFilters &&
      currentFilters.projects.length > 0 &&
      currentFilters.centers.length > 0 &&
      !isLoading &&
      !isFetching
    ) {
      filterCenters();
    }
  }, [currentFilters]);

  return (
    <LayoutFilters>
      <section className={viewClasess.dashboard}>
        <ResumeCards resume={currentCenters.resume} />

        <Title type="h2" color="primary" className={viewClasess.chartTitle}>
          {t('centersTitle')}
        </Title>

        {!isLoading ? (
          <Grid>
            <Col xss={12} xs={12} sm={12}>
              {currentCenters &&
              currentCenters.centers &&
              currentCenters.centers.length ? (
                [...currentCenters.centers]
                  .sort((a, b) => {
                    if (
                      filters.t(a.country_code) === filters.t(b.country_code)
                    ) {
                      return a.name < b.name ? -1 : 1;
                    }
                    return filters.t(a.country_code) < filters.t(b.country_code)
                      ? -1
                      : 1;
                  })
                  .map((center) => (
                    <div
                      key={center.uuid}
                      className={viewClasess.centerContainer}
                    >
                      <CenterCard center={center} />
                    </div>
                  ))
              ) : (
                <NotResults isLoading={isLoading} card />
              )}
            </Col>
          </Grid>
        ) : (
          <NotResults isLoading={isLoading} card />
        )}
      </section>
    </LayoutFilters>
  );
}

CentersView.propTypes = {};
